import React, { Component } from "react";
import "./Products.scss";

export default class Products extends Component {
  render() {
    return (
      <div>
        <ul className="products">
          {this.props.products.map((product) => (
            <li key={product.id} className="products__item">
              <div className="products__description">
                <img
                  src={product.image}
                  alt={product.title}
                  className="products__img"
                />
                <p className="products__title">{product.title}</p>
              </div>
              <div className="products__price">
                <p>{product.price}</p>
                <button
                  onClick={() => this.props.addToCart(product)}
                  className="products__button"
                >
                  Add to Cart
                </button>
              </div>
            </li>
          ))}
        </ul>
      </div>
    );
  }
}
